<nav class="navbar navbar-expand-md navbar-light shadow fixed-top row mx-0 pb-0">
	<div class="col-lg-2 px-0 d-flex flex-row justify-content-between">
		<a class="navbar-brand pb-0 mr-1" routerLink="/home">
			<img
				height="40px"
				src="./assets/imgs/logo_open_fiber_magenta.png?v={{ assets_version }}"
				srcset="./assets/imgs/logo_open_fiber_magenta@2x.png 2x"
			/>
			<span *ngIf="!prod" class="version align-self-end mb-2">{{ version }}</span>
		</a>
		<div>
			<button
				mat-raised-button
				*ngIf="
					router.url !== '/services-menu' &&
					router.url !== '/p2p_list' &&
					router.url !== '/contact' &&
					router.url !== '/sign_up'
				"
				class="toggle-view d-block d-md-none"
				(click)="toggleView()"
			>
				<i class="fas fa-map-marked-alt icon-search" [class.d-none-mobile]="showRight$ | async"></i>
				<img
					src="./assets/imgs/markers/ico_italy.png?v={{ assets_version }}"
					alt="'GENERAL.MAP' | translate"
					class="icon-italy"
					[class.d-none-mobile]="hideRight$ | async"
				/>
			</button>
		</div>
	</div>

	<div class="col-lg-8 px-0 d-none d-lg-block w-100">
		<div class="collapse navbar-collapse" id="navbarCollapse">
			<div class="navbar-nav m-auto">
				<div class="nav-item">
					<a class="nav-link" href="javascript:void(0);" routerLink="/home" routerLinkActive="active">
						{{ "MENU.FTTH" | translate }}
					</a>
				</div>

				<div class="nav-item">
					<a class="nav-link" href="javascript:void(0);" routerLink="/p2p" routerLinkActive="active">
						{{ "MENU.P2P" | translate }}
					</a>
				</div>

				<div (mouseenter)="activeTab = true" (mouseleave)="activeTab = false" (mouseover)="activeTab = true">
					<div class="nav-item submenu-trigger" [class.active-submenu]="activeTab">
						<a #submenuLink class="nav-link" href="javascript:void(0);">
							{{ "MENU.SERVICES" | translate }}
						</a>
						<div class="triangle" [class.d-none]="!activeTab"></div>
					</div>

					<div class="submenu d-flex justify-content-around" *ngIf="activeTab">
						<div class="submenu-block px-1">
							<p class="submenu-title">
								<a href="javascript:void(0);" routerLink="/pon">
									{{ "SERVICES_MENU.PON" | translate }}
								</a>
							</p>
							<p class="submenu-text">Open Stream (PON Ethernet)</p>
							<p class="submenu-text">Open Internet (Direct Internet Access)</p>
						</div>
						<div class="submenu-block px-1 pr-5">
							<p class="submenu-title">
								<a href="javascript:void(0);" routerLink="/p2p-access">
									{{ "SERVICES_MENU.POINT_TO_POINT" | translate }}
								</a>
							</p>
							<p class="submenu-text">Dark Fiber</p>
							<p class="submenu-text">Ethernet</p>
						</div>
						<div class="submenu-block px-1">
							<p class="submenu-title">
								<a href="javascript:void(0);" routerLink="/transport-infrastructure">
									Transport and Colo
								</a>
							</p>
							<p class="submenu-text">{{ "SERVICES_MENU.WAVELENGTH" | translate }}</p>
							<p class="submenu-text">{{ "SERVICES_MENU.COLOCATION" | translate }}</p>
						</div>
					</div>
				</div>

				<div class="nav-item" *ngIf="helpersService.isAdmin">
					<a class="nav-link" href="{{ baseUrl }}/backoffice/home">{{ "MENU.MANAGEMENT" | translate }}</a>
					<!-- <a class="nav-link" href="javascript:void(0);" routerLink="/p2p_list"
                        routerLinkActive="active">{{ "MENU.MANAGEMENT" | translate }}</a> -->
				</div>

				<div class="nav-item" *ngIf="helpersService.isAdmin">
					<a class="nav-link" href="javascript:void(0);" routerLink="/sign_up" routerLinkActive="active">
						{{ "MENU.SIGN_UP" | translate }}
					</a>
				</div>

				<div class="nav-item">
					<a class="nav-link" href="javascript:void(0);" routerLink="/contact" routerLinkActive="active">
						{{ "MENU.CONTACT" | translate }}
					</a>
				</div>
			</div>
		</div>
	</div>

	<div class="col-lg-2 px-0 user-dropdown-box">
		<h5 *ngIf="!prod" class="username">{{ userData?.username }}</h5>
		<app-user-dropdown [userData]="userData"></app-user-dropdown>
	</div>
</nav>
